import React from "react";
import { FaRobot, FaEye, FaBolt, FaPlug } from "react-icons/fa";

function Automation() {
  const features = [
    {
      title: "Automation",
      desc: "The bot automatically executes buy and sell orders across multiple exchanges based on predefined strategies, minimizing the need for manual intervention.",
      icon: <FaRobot size={35} />,
    },
    {
      title: "Real-Time Monitoring",
      desc: "It constantly monitors cryptocurrency prices across different exchanges in real-time to identify arbitrage opportunities.",
      icon: <FaEye size={35} />,
    },
    {
      title: "Speed",
      desc: "Since the price differences may only exist for a short time, arbitrage bots are designed to execute trades quickly, taking advantage of the time-sensitive nature of these opportunities.",
      icon: <FaBolt size={35} />,
    },
    {
      title: "Exchange Connectivity",
      desc: "Arbitrage bots are usually connected to several cryptocurrency exchanges via APIs to ensure they can access price data and execute trades efficiently.",
      icon: <FaPlug size={35} />,
    },
  ];
  return (
    <>
      <div
        className="services-area pt-120 pb-100"
        style={{ background: "#f8fafc" }}
      >
        <div className="container">
          <div className="row text-center mb-5">
            <div className="col-lg-8 offset-lg-2">
              <h4
                className="sub-title text-primary fw-bold mb-2"
                style={{
                  letterSpacing: "2px",
                  textTransform: "uppercase",
                  fontSize: "14px",
                }}
              >
                Platform Excellence
              </h4>
              <h2 className="title">
                Key Features Of Arbitrage Crypto Trading Bot
              </h2>
              <p className="mt-3 text-muted fs-5" style={{ lineHeight: "1.7" }}>
                We engineer highly functional DeFi staking solutions equipped to
                provide flexible and dynamic capacity as markets evolve.
              </p>
            </div>
          </div>

          <div className="row g-4">
            {features.map((feature, index) => (
              <div className="col-lg-3 col-md-6" key={index}>
                <div
                  className="feature-card p-5 h-100 text-center"
                  style={{
                    borderRadius: "32px",
                    background: "#ffffff",
                    border: "1px solid #e2e8f0",
                    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                    cursor: "pointer",
                    position: "relative",
                    overflow: "hidden",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-12px)";
                    e.currentTarget.style.boxShadow =
                      "0 30px 60px rgba(59, 130, 246, 0.12)";
                    e.currentTarget.style.borderColor = "#3b82f640";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                    e.currentTarget.style.borderColor = "#e2e8f0";
                  }}
                >
                  <div
                    className="icon-box mx-auto d-flex align-items-center justify-content-center mb-4"
                    style={{
                      width: "80px",
                      height: "80px",
                      fontSize: "32px",
                      background: "rgba(59, 130, 246, 0.05)",
                      color: "#3b82f6",
                      borderRadius: "22px",
                      transition: "all 0.3s ease",
                      border: "1px solid rgba(59, 130, 246, 0.1)",
                    }}
                  >
                    {feature.icon}
                  </div>

                  <h5
                    className="fw-800 mb-3"
                    style={{
                      fontSize: "20px",
                      color: "#1e293b",
                      fontFamily: "'Outfit', sans-serif",
                    }}
                  >
                    {feature.title}
                  </h5>

                  <p
                    style={{
                      fontSize: "15px",
                      color: "#64748b",
                      lineHeight: "1.7",
                      marginBottom: 0,
                    }}
                  >
                    {feature.desc}
                  </p>

                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      height: "4px",
                      background:
                        "linear-gradient(90deg, #3b82f6, transparent)",
                      opacity: 0,
                      transition: "opacity 0.3s",
                    }}
                    className="hover-line"
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <style>{`
        .feature-card:hover .hover-line {
            opacity: 1 !important;
        }
        .feature-card:hover .icon-box {
            background: #3b82f6 !important;
            color: #fff !important;
            transform: scale(1.1);
        }
      `}</style>
      </div>
    </>
  );
}

export default Automation;
